import { render, staticRenderFns } from "./UploadAvatarImage.vue?vue&type=template&id=a16be09a&scoped=true&"
import script from "./UploadAvatarImage.vue?vue&type=script&lang=js&"
export * from "./UploadAvatarImage.vue?vue&type=script&lang=js&"
import style0 from "./UploadAvatarImage.vue?vue&type=style&index=0&id=a16be09a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a16be09a",
  null
  
)

export default component.exports